import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

import WrapperContainer from "../../components/WrapperContainer/WrapperContainer.jsx";
import Button from "../../components/Button/Button.jsx";

import ButtonsGroup from "../../components/ButtonsGroup/ButtonsGroup.jsx";
import { getRemainingTime } from "../../utils/helpers/getRemainingTime.js";

const FormConfirmPhoneNumber = ({
  isDisabledButton,
  isSuccessConfirmSmsCode,
  phoneNumber,
  remainingSeconds,
  getSmsCode,
  confirmSmsCode,
  ...rest
}) => {
  const history = useNavigate();

  return (
    <>
      <WrapperContainer gap="16" title="sm">
        Подтверждение
      </WrapperContainer>
      <WrapperContainer className="forms-container__content">
        <form onSubmit={event => event.preventDefault()}>
          <WrapperContainer gap="24">
            <WrapperContainer text="lg" gap="24">
              На номер <b>+{phoneNumber}</b> поступит СМС - код.
            </WrapperContainer>

            <WrapperContainer gap="16">{rest.children}</WrapperContainer>

            {!isSuccessConfirmSmsCode && (
              <WrapperContainer gap="24">
                {remainingSeconds ? (
                  <WrapperContainer text="md" className="text-color-dark-gray">
                    Новый код можно получить через {getRemainingTime(remainingSeconds)}
                  </WrapperContainer>
                ) : (
                  <Button color="secondary" size="sm" onClick={getSmsCode}>
                    Отправить код повторно
                  </Button>
                )}
              </WrapperContainer>
            )}
          </WrapperContainer>

          <ButtonsGroup>
            <Button isStretch color="secondary" size="xl" onClick={() => history(-1)}>
              Назад
            </Button>
            <Button
              isSubmit
              isStretch
              color="primary"
              size="xl"
              onClick={confirmSmsCode}
              disabled={!remainingSeconds || isDisabledButton}
            >
              Далее
            </Button>
          </ButtonsGroup>
        </form>
      </WrapperContainer>
    </>
  );
};

FormConfirmPhoneNumber.propTypes = {
  isDisabledButton: PropTypes.bool.isRequired,
  isSuccessConfirmSmsCode: PropTypes.bool.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  remainingSeconds: PropTypes.number.isRequired,
  getSmsCode: PropTypes.func.isRequired,
  confirmSmsCode: PropTypes.func.isRequired,
};

export default FormConfirmPhoneNumber;
